import { TrendingDown, TrendingUp } from 'lucide-react';
import AnalyticsInfoHint from './AnalyticsInfoHint';

/**
 * Variation vs période précédente — wording commerçant.
 */
export function DeltaBadge({ value, periodHint }) {
  const hint =
    periodHint ||
    'Comparaison avec la période précédente de même durée (juste avant la période affichée).';

  if (value == null || value === 0) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-gray-400">
        — par rapport à la période précédente
        <AnalyticsInfoHint text={hint} label="Comparaison de période" />
      </span>
    );
  }
  const up = value > 0;
  const Icon = up ? TrendingUp : TrendingDown;
  const abs = Math.abs(Number(value));
  const formatted = String(abs).replace('.', ',');
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium ${
        up ? 'text-emerald-600' : 'text-red-600'
      }`}
    >
      <Icon className="h-3.5 w-3.5" aria-hidden />
      {up ? '+' : '−'}
      {formatted} % par rapport à la période précédente
      <AnalyticsInfoHint text={hint} label="Comparaison de période" />
    </span>
  );
}
